import { transformArrayToSelectOptions } from 'utils/transformArrayToSelectOptions';

export const getDefaultCustomerFormValues = (
  fields,
  cartUUID,
  customerform,
) => {
  const defaultValuesForCustomerForm = {};
  const completedFields = { ...fields[cartUUID][0] };
  for (let key in completedFields) {
    if (Array.isArray(completedFields[key])) {
      const field = customerform?.find(item => item.id === key);
      const fieldOptions = field ? field.meta.options : [];

      if (field && field.meta.multiple === undefined) {
        defaultValuesForCustomerForm[`customer-${key}`] = {
          value: fieldOptions[completedFields[key]],
          label: fieldOptions[completedFields[key]],
        };
      } else if (field && field.meta.multiple === '1') {
        let result: string[] = [];
        for (let i = 0; i < completedFields[key].length; i++) {
          result.push(fieldOptions[completedFields[key][i]]);
        }
        defaultValuesForCustomerForm[`customer-${key}`] =
          transformArrayToSelectOptions(result);
      }
    } else {
      defaultValuesForCustomerForm[`customer-${key}`] = completedFields[key];
    }
  }
};
